<div class="grid" *ngIf="exibirSpinnerPrincipal">
    <div class="col-12">
        <div class="card">
            <div class="flex justify-content-center">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>
    </div>
</div>

<div class="grid" *ngIf="!exibirSpinnerPrincipal">
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full">
            <span class="font-bold text-xl">ABERTO</span>
            <div class="flex justify-content-between align-items-start mt-3">
                <div class="w-6">
                    <span class="text-4xl font-bold text-900">{{monitoramento?.totalAberto}}</span>

                </div>
                <div class="w-6 text-right">
                    <i class="pi pi-inbox text-4xl mr-2"></i>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full">
            <span class="font-bold text-xl">RECEBIDO</span>
            <div class="flex justify-content-between align-items-start mt-3">
                <div class="w-6">
                    <span class="text-4xl font-bold text-900">{{monitoramento?.totalRecebido}}</span>

                </div>
                <div class="w-6 text-right">
                    <i class="pi pi-check-square text-4xl mr-2"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full">
            <span class="font-bold text-xl">EM ATENDIMENTO</span>
            <div class="flex justify-content-between align-items-start mt-3">
                <div class="w-6">
                    <span class="text-4xl font-bold text-900">{{monitoramento?.totalEmAtendimento}}</span>

                </div>
                <div class="w-6 text-right">
                    <i class="pi pi-phone text-4xl mr-2"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full">
            <span class="font-bold text-xl">MEDIA AVALIAÇÃO</span>
            <div class="flex justify-content-center align-items-start mt-3">
                <div class="text-center">
                    <p-rating [(ngModel)]="mediaAvaliacaoArredonda" [cancel]="false" class="rating-grande mb-2"
                        [readonly]="true">
                    </p-rating>
                    <span class="text-4xl font-bold text-900">{{mediaAvaliacao.toFixed(2)}}</span>
                </div>

            </div>
        </div>

    </div>


    <div class="col-12 xl:col-7">
        <div class="card h-full">
            <div class="flex align-items-start justify-content-between mb-6">
                <span class="text-900 text-xl font-semibold">
                        <i class="pi pi-envelope font-bold text-xl mr-1"></i>
                        Encerrados nos últimos
                        {{filtroGraficoBarraSelecionado.toString()}} dias</span>
            </div>
            <div *ngIf="monitoramentoGraficoBarra.length === 0"
                class="flex justify-content-center align-items-center h-17rem text-xl text-700">
                {{loadingGraficosPrimeiraVez ? 'Carregando dados':'Sem dados para exibir'}}
            </div>
            <p-chart *ngIf="monitoramentoGraficoBarra.length > 0" type="bar" [data]="barData" [options]="barOptions" height="300px"
                [plugins]="pluginGraficos"></p-chart>
        </div>
    </div>
    <div class="col-12 xl:col-5">
        <div class="card h-full text-center">
            <div class="flex justify-content-between mb-5">
                <div class="text-900 text-xl font-semibold mb-3">
                    <i class="pi pi-th-large text-xl mr-1"></i>
                    Tipos de Atendimento
                </div>
                <p-dropdown [options]="filtroGraficoPizza" [(ngModel)]="filtroGraficoPizzaSelecionado"
                    (onChange)="carregarMonitoramentoGraficoPizza()" optionLabel="label" optionValue="value"
                    styleClass="w-9rem" optionLabel="label"></p-dropdown>
            </div>
            <div *ngIf="monitoramentoGraficoPizza.length === 0"
                class="flex justify-content-center align-items-center h-17rem text-xl text-700">
                {{loadingGraficosPrimeiraVez ? 'Carregando dados':'Sem dados para exibir'}}
            </div>
            <p-chart *ngIf="monitoramentoGraficoPizza.length > 0" type="pie" [data]="pieData" [options]="pieOptions" height="300px"
                [plugins]="pluginGraficos"></p-chart>
        </div>
    </div>

    <div class="col-12 lg:col-12">
        <div class="card">
            <div class="flex flex-column md:flex-row md:align-items-start md:justify-content-between mb-3">
                <div class="text-900 text-xl font-semibold mb-3 md:mb-0">
                    <i class="pi pi-envelope mr-1 font-bold"></i>
                    Atendimentos
                </div>
                
            </div>
            <p-table #dt1 [value]="listaChamados" dataKey="id" [rowHover]="true" [loading]="loading"
                [rows]="itensPaginados ? itensPaginados.size : 0" [paginator]="true" (onLazyLoad)="onLazyLoad($event)"
                [totalRecords]="itensPaginados ? itensPaginados.totalElements : 0" [lazy]="true"
                [showCurrentPageReport]="true" responsiveLayout="stack" styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros">
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex flex-column sm:flex-row">
                            <div class="p-fluid sm:mr-2">
                                <label>Solicitação</label>
                                <p-dropdown [options]="listaFiltroSolicitado" optionLabel="label" optionValue="value"
                                    emptyFilterMessage="Nenhum registro" name="solicitadoFiltro" ngModel
                                    #solicitadoFiltro="ngModel" placeholder="Selecione"
                                    [(ngModel)]="solicitadoSelecionado" (onChange)="alterarFiltro(dt1)">
                                </p-dropdown>
                            </div>
                            <div class="p-fluid mt-2 sm:mt-0 sm:mr-2">
                                <label>Situação</label>
                                <p-dropdown [options]="listaStatus" optionLabel="label" optionValue="value"
                                    emptyFilterMessage="Nenhum registro" name="situacao" ngModel #situacao="ngModel"
                                    placeholder="Selecione" [(ngModel)]="statusSelecionado"
                                    (onChange)="alterarFiltro(dt1)">
                                </p-dropdown>
                            </div>
                            <div class="p-fluid mt-2 sm:mt-0 sm:mr-2">
                                <label>Tipo</label>
                                <p-dropdown [options]="listaTiposAtendimento" optionLabel="label" optionValue="value"
                                    emptyFilterMessage="Nenhum registro" name="tipoAtendimento" ngModel
                                    #tipoAtendimento="ngModel" placeholder="Selecione"
                                    [(ngModel)]="tipoAtendimentoSelecionado" (onChange)="alterarFiltro(dt1)">
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="p-fluid mt-2 sm:mt-4">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" [(ngModel)]="inputBusca" (input)="buscar(dt1, $event)"
                                     placeholder="Buscar" class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>
						</div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="empresa.nomeFantasia">
                            Empresa
                            <p-sortIcon field="empresa.nomeFantasia">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="protocolo">
                            Protocolo
                            <p-sortIcon field="protocolo">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="dataCriacao">
                            Data
                            <p-sortIcon field="dataCriacao">
                            </p-sortIcon>
                        </th>
                        <th>
                            Situação
                        </th>
                        <th>
                            Tipo
                        </th>
                        <th>
                            Ações
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{item.empresa.nomeFantasia}}
                        </td>
                        <td>
                            {{item.protocolo}}
                        </td>
                        <td>
                            {{item.dataCriacao | date:'dd/MM/yyyy HH:mm:ss'}}
                        </td>
                        <td>
                            {{item.statusFormatado }}
                        </td>
                        <td>
                            {{item.tipoFormatado}}
                        </td>
                        <td>
                            <button pButton class="p-button-primary" icon="pi pi-comments" pTooltip="Acessar conversa"
                                (click)="redirecionarPagina('/rfarias/suporte/chat/' + item.id)">
                            </button>
                        </td>
                    </tr>

                </ng-template>
            </p-table>
        </div>
    </div>

</div>